import { webRadiansToAzimuth } from "@logic/lib/design"
import { angleOutOf, angleInto } from "@logic/lib/mesh"

import type { TransactionOperation } from "."
import { projectFace, findAreaState } from "../areas"
import { projectEdge, findEdgeState } from "../edges"
import type { AreaActionTo_, UnknownChangeForUnknownElement } from "../timeline"
import { generateElementChange } from "../timeline/transactions"

type ReorientAreasOptions = {
  edgeId: string
  areaId: string
  edgeType: string
}

export const findAzimuth: TransactionOperation<
  ReorientAreasOptions,
  UnknownChangeForUnknownElement
> = (transactors, { edgeId, areaId, edgeType }) => {
  const { get, set } = transactors
  const areaState = findAreaState(areaId)
  const computedEdge = projectEdge(get, edgeId, findEdgeState)
  const prev = projectFace(get, areaId, findAreaState)
  const next = {
    ...prev,
    azimuth: webRadiansToAzimuth(
      edgeType === `eave`
        ? angleOutOf(prev).from(computedEdge)
        : angleInto(prev).from(computedEdge),
    ),
    azimuthLocked: true,
  }
  const redoAreaUpdate: AreaActionTo_[`UPDATE`] = {
    type: `UPDATE`,
    family: `AREA`,
    id: areaId,
    payload: {
      azimuth: Math.round(next.azimuth),
      azimuthLocked: next.azimuthLocked,
    },
  }
  const areaReorientation = generateElementChange(transactors, {
    action: redoAreaUpdate,
  })
  set(areaState, next)

  return areaReorientation
}
